@if (!notFoundProducts) {
  @if (activeOrder) {
    <div class="products-grid">
      @for (product of activeProducts; track product) {
        <div class="products-grid__item">
          <app-product-grid-item
            [product]="product"
            [order]="activeOrder"
          ></app-product-grid-item>
        </div>
      }
    </div>
  }
} @else {
  @if (showNotFoundMessage) {
    <div class="font-4 d-block text-align-center">Nothing Found</div>
  }
}
